export const SET_PAGE = 'SET PAGE';
export function setPage(page){
	return { type: SET_PAGE, page: parseInt(page, 10)}
}

export const SET_PAGE_TOTAL = 'SET_PAGE_TOTAL';
export function setPageTotal(total){
	return { type: SET_PAGE_TOTAL, total: parseInt(total, 10) }
}



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/actions/page.js